import * as Sentry from '@sentry/vue';

export default function install(Vue, router) {
  if (process.env.SENTRY.DNS) {
    Sentry.init({
      Vue,
      dsn: process.env.SENTRY.DNS,
      release: process.env.NODE_ENV,
      environment: process.env.NODE_ENV,
      ignoreErrors: ['ResizeObserver loop limit exceeded'],
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      sampleRate: 0.25,
      tracesSampleRate: 0.25,
    });
  }
}
